import React, { ReactElement, useState, useEffect } from "react";
import { getMicrositeWidgetById, getStorageFileUrl } from "../../apis/firebase";

const Documents = ({ data }): ReactElement => {
  const [response, setIsResponse] = useState<any>({});

  useEffect(() => {
    (async () => {
      if (!!data.documents && data.documents.length) {
        data.documents = await Promise.all(
          data?.documents?.map(async (d) => {
            let _d = d;
            if (_d.docId) {
              _d = _d.docId;
            }
            return await getMicrositeWidgetById("documents", _d);
          })
        );
      }
      if (!!data.documents && data.documents.length) {
        data.documents = await Promise.all(
          data?.documents?.map(async (d) => {
            d.file = !!d.file ? await getStorageFileUrl(d.file) : "";
            return d;
          })
        );
      }
      setIsResponse(data);
    })();
  }, [data]);

  return (
    <>
      {!!response && (
        <div className="mt-5">
          <div className="tm__content">
            <div className="tm__content-head d-flex justify-content-between">
              <h2 className="fw-bold m-0">{response.title}</h2>
            </div>
            {!!response.description && (
              <div className="tm__content-body">
                <p
                  dangerouslySetInnerHTML={{
                    __html: response.description,
                  }}></p>
              </div>
            )}
          </div>

          {!!response.documents && (
            <div className="d-flex flex-column">
              {response.documents.map((document, i) => (
                <div
                  key={i}
                  className="tm__list d-flex align-items-center mb-3 p-3">
                  <div className="d-flex flex-column flex-md-row flex-1 me-3">
                    <div className="d-flex flex-column justify-content-center flex-1 lh-sm">
                      <label className="fs-5 text-primary">
                        {document.title}
                      </label>
                      <small className="fs-7">{document.description}</small>
                    </div>
                  </div>
                  {document.file && (
                    <div className="flex-shrink-0">
                      <a
                        href={document.file}
                        className="tm__list-icon bi bi-cloud-download"
                        download={document.title}
                        target="_blank"></a>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Documents;
